<template>
  <el-dialog title="更改订单" :visible.sync="dialogTableVisible" width="25%" :append-to-body="true" :close-on-click-modal="false">
    <template slot="title">
      <div class="title">更改订单</div>
    </template>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="订单状态" prop="resource">
        <el-radio-group v-model="ruleForm.resource" @change="radiochange">
          <el-radio label="已发货"></el-radio>
          <el-radio label="取消订单"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="cancelIndet" label="物流单号" prop="order">
        <el-input v-model="ruleForm.order" placeholder="请输入物流单号"></el-input>
      </el-form-item>
      <el-form-item v-show="cancelIndet" label="物流公司" prop="company">
        <el-input v-model="ruleForm.company" placeholder="请输入物流公司"></el-input>
      </el-form-item>

      <el-form-item v-show="!cancelIndet" label="取消原因">
        <el-input type="textarea" maxlength="100" placeholder="请输入订单取消的原因" v-model="ruleForm.desc"></el-input>
      </el-form-item>

      <el-form-item label-width="150px">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        dialogTableVisible: false,
        cancelIndet: true,
        ruleForm: {resource: '已发货'},
        rules: {
          resource: [
            {required: true, message: "请选择订单状态", trigger: "change"}
          ],
          order: [
            {required: true, message: "请输入物流单号", trigger: "blur"}
          ]
        }
      };
    },
    methods: {
      // 单选框事件
      radiochange(e) {
        console.log(e);
        if (e === "已发货") {
          this.cancelIndet = true;
        } else if (e === "取消订单") {
          this.cancelIndet = false;
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.ruleForm.resource == "已发货") {
              this.$axios
                .post(this.$url.deliver, {
                  id: this.id,
                  ...this.ruleForm
                })
                .then(res => {
                  console.log("我是发货接口");
                  if (res.code == 0) {
                    this.$message.success("修改成功");
                    this.dialogTableVisible = false;
                    this.$emit("action",'fahuo')
                  }
                });
            } else {
              this.$axios
                .post(this.$url.cancelOrder, {
                  id: this.id,
                  cancelReason: this.ruleForm.desc
                })
                .then(res => {
                  console.log("我是取消订单", res);
                  if (res.code == 0) {
                    this.$message.success("修改成功");
                    this.dialogTableVisible = false;
                    this.$emit("action",'quxiao')

                  }
                });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.dialogTableVisible = false;
        this.ruleForm = {resource: '已发货'};
        this.cancelIndet = true;
        // this.$forceUpdate();
      }

    }
  };
</script>

<style lang='less' scoped>
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(72, 72, 72, 1);
  }

  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }

  ::v-deep .el-input__inner {
    width: 320px;
    height: 36px;
  }

  ::v-deep .el-textarea__inner {
    width: 320px;
    height: 96px;
  }
</style>
